// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".m-form-text.is-disabled[data-v-211bcaf0]{background:#efeef2}.m-form-text.is-disabled[data-v-211bcaf0]::placeholder{color:#ccc8d7}.m-form-text[data-v-211bcaf0]::placeholder{color:rgba(153,153,153,.5);font-size:1.4rem}", ""]);
// Exports
module.exports = exports;
